module.exports = __webpack_public_path__ + "static/dg-logo-shadow-eb7b12a4679ceb01357580bc1b664689.png";